import React from 'react';

const ImageOptimized = ({ src, alt }) => (
    <picture>
        <source srcSet={`${src}-small.webp`} media="(max-width: 580px)" />
        <img src={`${src}-large.webp`} alt={alt} loading="lazy" />
    </picture>
);

export default ImageOptimized;
